import * as Utils from "../utils/Config";
import { ApiClient, IPaginatedResponse } from "./ApiClient";
import { IPatient, IPatientRefrainingFreeDentalCare } from "../models/IPatient";
import { IPage } from "../models/IPage";
import { objectToQueryString } from "../helpers/ApiHelper";

export interface PatientModel {
    name: string;
    id: number;
    personalSecurityNumber: string;
}

export class PatientApi extends ApiClient {
    getPatient(patientGuidId: string, success: (data: IPatient) => void, error?: (message: string) => void, final?: () => void) {
        this.get<IPatient>(`${Utils.LIB_API_BASE_URL}/patient/${patientGuidId}`, success, error, final);
    }

    getPatientData(patientGuidId: string, success: (data: IPatient) => void, error?: (message: string) => void, final?: () => void) {
        this.get<IPatient>(`${Utils.LIB_API_BASE_URL}/patient/patientData/${patientGuidId}`, success, error, final);
    }

    refrainFreeDentalCare(patientId: number, success: () => void, error?: (message: string) => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/patient/${patientId}/refrainFreeDentalCare`, null, success, error);
    }

    reactivateFreeDentalCare(patientId: number, success: () => void, error?: (message: string) => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/patient/${patientId}/reactivateFreeDentalCare`, null, success, error);
    }

    getPatientGuidId(inputString: string, success: (patientGuidId: string) => void, error?: (message: string) => void, final?: () => void) {
        this.get<string>(`${Utils.LIB_API_BASE_URL}/patient/patientGuidId/${inputString}`, success, error, final);
    }

    getPatientsRefrainingFreeDentalCare(pagingParams: IPage, success: (data: IPaginatedResponse<IPatientRefrainingFreeDentalCare[]>) => void, error?: (message: string) => void, final?: () => void) {
        const queryString = objectToQueryString(pagingParams);
        this.getPaginated<IPatientRefrainingFreeDentalCare[]>(`${Utils.LIB_API_BASE_URL}/patient/refrainingFreeDentalCare?${queryString}`, success, error, final);
    }

    getPatientsRefrainingFreeDentalCareAsExcel(pagingParams: IPage, fileName: string, success?: () => void, error?: (message: string) => void, final?: () => void) {
        const queryString = objectToQueryString(pagingParams);
        this.getFile(`${Utils.LIB_API_BASE_URL}/patient/refrainingFreeDentalCare?${queryString}&exportToExcel=true`, fileName, success, error, final);
    }
}

